// extracted by mini-css-extract-plugin
export default {"colorMode":"ColorMode_colorMode__hA+jf"};